import { Template } from '../types/project'

export const PROJECT_TEMPLATES: Template[] = [
  {
    title: 'Travel Collab',
    id: 'travel',
    icon: '✈️',
    project: {
      title:
        '✈️ Share the story of your latest Travel project with potential partners and collaborators',
      description: `
        <p>Hey creator! This is your chance to tell the story of your travel project. Follow this structure to create a compelling narrative:</p><p style="text-align: start"><strong>Introduction:</strong> Who did you work with and why was this exciting?</p><p style="text-align: start">Example: "My recent partnership with <a target="_blank" rel="noopener noreferrer nofollow" href="https://www.notion.so/5ed825d7d2d94d8fbaa8ce187851c603?pvs=21">Hilton Hotels</a> was a highlight of my creative career. Having made some of my best memories at Hilton properties worldwide, I was thrilled to collaborate with them for the first time."</p><p style="text-align: start"><strong>Location and Experience:</strong> Where did you go and what did you do? Example: "We spent three unforgettable days in Playa Del Carmen, Mexico, experiencing Hilton's newest resort. From zip-lining through lush jungles to savoring 5-star Mexican cuisine and relaxing beachside, every moment was an adventure."</p><p style="text-align: start"><strong>Deliverables</strong>: What content did you produce? Example: My deliverables included…</p><ul><li><p>Daily one-minute video posts across my three main social networks</p></li><li><p>A 5-minute comprehensive video review of the property and its offerings</p></li><li><p>3 weeks of featuring Hilton's booking link in my social media bios</p></li></ul><p style="text-align: start"><strong>Collaboration Experience:</strong> How was working with the brand?</p><p style="text-align: start">Example: The Hilton team made this one of my most enjoyable projects ever. Their support ensured both sides were thrilled with the results. I would definitely work with them again.</p><p style="text-align: start"><strong>Impact and Future Opportunities:</strong> How did this project benefit you and the brand?</p><p style="text-align: start">[Add your own text here about the project's success and your interest in similar collaborations]</p><p style="text-align: start"><em>Remember to customize each section with your unique experience and voice!</em></p>
      `,
      role: {
        title:
          '[Choose the title that best describes your primary function, e.g., Content Creator, Travel Influencer, Videographer]',
        description:
          "[Describe your key responsibilities and how they contributed to the project's success]",
        organization:
          'What Organization were you working with in this role? [Enter the brand name]',
      },
      links: [
        {
          name: "My viral TikTok at Hilton's infinity pool",
          url: 'https://www.example.com',
        },
        {
          name: "Featured in Hilton's summer campaign",
          url: 'https://www.example.com/brand-feature',
        },
        {
          name: 'Key Contact: [Your manager’s name]',
          url: 'https://www.example.com/creatorland-profile',
        },
        {
          name: 'Key Contact: [Name of your contact at the partner brand]',
          url: 'https://www.example.com/creatorland-profile',
        },
      ],
      insights: [
        {
          title: '👀 Total Views',
          description: '1.2M across all platforms',
        },
        {
          title: "🎯 Clicks to Partner's Site",
          description: "15,000 to Hilton's booking page",
        },
        {
          title: '💬 Engagement Rate',
          description: '8.5% (2x my average)',
        },
        {
          title: '🏆 ROI for Brand',
          description: '$50,000 in attributed bookings',
        },
      ],
      contentType: [
        'Advertising & Marketing',
        'Art & Photography',
        'Creativity & Leisure',
        'Food & Drink',
        'Lifestyle',
        'Travel',
        'Hotels & Hospitality',
        'Affiliate Promotions',
        'Ambassdaor or Sponsorship',
        'Instagram Reel(s) Review',
        'TikTok Post(s)',
        'Star In',
      ],
    },
  },
  {
    title: 'TikTok Brand Collab',
    id: 'tiktok_brand_collab',
    icon: '🎵',
    project: {
      title: '🎵 [Brand] x [Your Name]: Viral TikTok Collab',
      description: `
        <p>Hey TikTok creator! Here's your chance to showcase your viral sponsored content. Follow this structure to create a compelling project description:</p><p style="text-align: start"><strong>Introduction</strong>: What was the collab and why were you excited?</p><p style="text-align: start">Example: "I recently partnered with [Brand Name] to create a sponsored TikTok showcasing their [Product Name]. As a long-time fan of their products, this collaboration was a perfect fit for my content and audience."</p><p style="text-align: start"><strong>Content Strategy</strong>: What was your approach?</p><p style="text-align: start">Example: "My strategy was to create a fun, engaging video that seamlessly integrated [Brand's] [Product] into my typical content style. I chose to use the trending [Song/Sound] as it perfectly complemented the product's vibe."</p><p style="text-align: start"><strong>Video Description</strong>: What did you create?</p><p style="text-align: start">Example: "The 60-second video featured me [briefly describe what you did in the video, e.g., 'demonstrating three unique ways to use the product']. I incorporated [Brand's] key messaging points while maintaining my authentic voice and humor that my followers love."</p><p style="text-align: start"><strong>Challenges and Solutions</strong>: Any obstacles you overcame?</p><p style="text-align: start">Example: "The main challenge was [e.g., 'showcasing the product's features in just 60 seconds']. I overcame this by [e.g., 'using quick transitions and on-screen text to highlight key points']."</p><p style="text-align: start"><strong>Results and Impact</strong>: How did the video perform?</p><p style="text-align: start">Example: "The video exceeded both my and [Brand's] expectations, garnering over [X] views, [Y] likes, and [Z] shares within the first 48 hours. It sparked a wave of user-generated content with the hashtag #[BrandCampaign], further amplifying the campaign's reach."</p><p style="text-align: start"><strong>Learnings and Future Opportunities</strong>: What did you gain from this experience?</p><p style="text-align: start">Example: "This collaboration allowed me to refine my skills in creating engaging sponsored content while staying true to my style. The success of this video has opened doors for future brand partnerships in the [relevant industry] space."</p><p style="text-align: start"><em>Remember to infuse your unique voice and style throughout the description!</em></p>
      `,
      role: {
        title: 'TikTok Creator, Content Strategist, Video Producer',
        description:
          '[Describe your key responsibilities, from conceptualization to execution and reporting]',
        organization:
          'What Organization were you working with in this role? [Enter the brand name]',
      },
      links: [
        {
          name: 'Viral TikTok for [Brand]',
          url: 'https://www.example.com',
        },
        {
          name: 'Behind-the-scenes Instagram Story',
          url: 'https://www.example.com/behind-the-scenes',
        },
        {
          name: 'Key Contact: [Your manager’s name]',
          url: 'https://www.example.com/creatorland-profile',
        },
        {
          name: 'Key Contact: [Name of your contact at the partner brand]',
          url: 'https://www.example.com/creatorland-profile',
        },
      ],
      insights: [
        {
          title: '👀 Views',
          description: '2.5M in first week',
        },
        {
          title: '❤️ Engagement Rate',
          description: '15% (3x my average)',
        },
        {
          title: '🔁 Shares',
          description: '50K, sparking UGC trend',
        },
        {
          title: '🛒 Product Sales',
          description: '1,500 units via my link',
        },
        {
          title: '📈 Follower Growth',
          description: '20K new followers post-campaign',
        },
      ],
      contentType: [
        'Advertising & Marketing',
        'Entrepreneurship',
        'Fashion & Style',
        'Lifestyle',
        'Health & Fitness',
        'Shopping & retail',
        'Affiliate Promotions',
        'Ambassdaor or Sponsorship',
        'TikTok Shop',
        'TikTok Post(s) Review',
        'Share',
        'Star In',
      ],
    },
  },
  {
    title: 'Health & Wellness Collab',
    id: 'health_wellness_collab',
    icon: '💪',
    project: {
      title: '💪 Elevating Wellness: [Your Name] x [Brand] Collaboration',
      description: `
        <p>Hello, wellness warrior! Here's your chance to showcase your impactful health and wellness collaboration. Follow this structure to create a compelling project description:</p><p style="text-align: start"><strong>Introduction</strong>: What was the collaboration and why was it a good fit?</p><p style="text-align: start">Example: "I recently partnered with [Brand Name] to promote their [Product/Service Name]. As a certified [your credentials, e.g., 'yoga instructor' or 'nutritionist'], this collaboration aligned perfectly with my mission to help my audience achieve holistic well-being."</p><p style="text-align: start"><strong>Project Goals</strong>: What were you aiming to achieve?</p><p style="text-align: start">Example: "Our primary goals were to educate my audience about [specific health benefit or wellness practice], demonstrate the effectiveness of [Brand's] [Product/Service], and inspire my followers to prioritize their health and wellness."</p><p style="text-align: start"><strong>Content Creation</strong>: What did you produce?</p><p style="text-align: start">Example: "For this campaign, I created:</p><ul><li><p>A series of 5 Instagram posts showcasing different uses of [Product]</p></li><li><p>3 in-depth IGTV videos providing [wellness tips/product tutorials]</p></li><li><p>A 4-week wellness challenge for my followers, incorporating [Brand's] [Product/Service]</p></li></ul><p style="text-align: start"><strong>Unique Approach</strong>: How did you make the content engaging and authentic?</p><p style="text-align: start">Example: "To ensure the content resonated with my audience, I [e.g., 'shared my personal journey with the product', 'created easy-to-follow workout routines', 'developed healthy recipes incorporating the product']. This approach allowed me to authentically integrate [Brand's] messaging while providing real value to my community."</p><p style="text-align: start"><strong>Challenges and Solutions</strong>: Any obstacles you overcame?</p><p style="text-align: start">Example: "The main challenge was [e.g., 'explaining complex health benefits in an accessible way']. I addressed this by [e.g., 'using relatable analogies and creating simple infographics']."</p><p style="text-align: start"><strong>Results and Impact</strong>: How did the collaboration perform?</p><p style="text-align: start">Example: "The campaign exceeded our expectations. We saw a [X%] increase in engagement across my platforms, and [Brand] reported a [Y%] uplift in sales during the campaign period. Most importantly, I received numerous messages from followers sharing how the content positively impacted their wellness journeys."</p><p style="text-align: start"><strong>Learnings and Future Opportunities</strong>: What did you gain from this experience?</p><p style="text-align: start">Example: "This collaboration deepened my expertise in [specific area of wellness] and honed my skills in creating educational yet engaging content. The success of this campaign has opened doors for future partnerships in the health and wellness space."</p><p style="text-align: start"><em>Remember to infuse your unique voice and wellness philosophy throughout the description!</em></p>
      `,
      role: {
        title: '[e.g., Wellness Influencer, Health Coach, Fitness Expert]',
        description:
          '[Describe your key responsibilities, from content creation to community engagement]',
        organization:
          'What Organization were you working with in this role? [Enter the brand name]',
      },
      links: [
        {
          name: 'Most popular Instagram post',
          url: 'https://www.example.com',
        },
        {
          name: 'Wellness challenge kick-off video',
          url: 'https://www.example.com/challenge-video',
        },
        {
          name: 'Key Contact: [Your manager’s name]',
          url: 'https://www.example.com/creatorland-profile',
        },
        {
          name: 'Key Contact: [Name of your contact at the partner brand]',
          url: 'https://www.example.com/creatorland-profile',
        },
      ],
      insights: [
        {
          title: '👥 Reach',
          description: '500K+ across all platforms',
        },
        {
          title: '💬 Engagement Rate',
          description: '12% (2x my average)',
        },
        {
          title: '🏆 Challenge Participants',
          description: '10K joined the 4-week program',
        },
        {
          title: '📈 Brand Impact',
          description: '20% increase in product sales',
        },
        {
          title: '💚 Community Feedback',
          description: '500+ positive testimonials received',
        },
      ],
      contentType: [
        'Health & Fitness',
        'Mind & Body',
        'Lifestyle',
        'Medical & health',
        'Sports & Recreation',
        'Affiliate Promotions',
        'Ambassador or Sponsorship',
        'Instagram Reel(s) Review',
        'Share',
      ],
    },
  },
  {
    title: 'IG Post, Story or Reels Collab',
    id: 'ig_post_story_reels_collab',
    icon: '📸',
    project: {
      title:
        '📸 Instagram Impact: [Your Name] x [Brand] [Post/Story/Reels] Collaboration',
      description: `
        <p>Hey Instagram creator! Here's your chance to showcase your stellar [Post/Story/Reels] collab. Follow this structure to create a compelling project description:</p><p style="text-align: start"><strong>Introduction</strong>: What was the collaboration and why was it exciting?</p><p style="text-align: start">Example: "I recently partnered with [Brand Name] to create a series of [Posts/Stories/Reels] featuring their [Product/Service]. This collaboration was a perfect fit for my aesthetic and allowed me to push my creative boundaries on Instagram."</p><p style="text-align: start"><strong>Content Strategy</strong>: What was your approach?</p><p style="text-align: start">Example: "My strategy was to create visually stunning [Posts/Stories/Reels] that seamlessly integrated [Brand's] [Product/Service] into my signature style. For [Posts/Reels], I focused on [e.g., 'creating a cohesive feed aesthetic']. For Stories, I emphasized [e.g., 'interactive elements to boost engagement'].</p><p style="text-align: start"><strong>Content Description</strong>: What did you create?</p><p style="text-align: start">Example: "The campaign included:</p><ul><li><p>[X] feed posts showcasing [Product/Service] in different settings</p></li><li><p>A series of [Y] Stories featuring [e.g., 'behind-the-scenes content, tutorials, polls']</p></li><li><p>[Z] Reels demonstrating [e.g., 'creative uses of the product, trending transitions']</p></li></ul><p style="text-align: start"><strong>Technical Aspects</strong>: How did you optimize for Instagram?</p><p style="text-align: start">Example: "For Reels, I leveraged trending audio and popular transitions to boost discoverability. In Stories, I used interactive stickers like polls and questions to increase engagement. For feed posts, I crafted captions with strategic hashtags to expand reach."</p><p style="text-align: start"><strong>Challenges and Solutions</strong>: Any obstacles you overcame?</p><p style="text-align: start">Example: "The main challenge was [e.g., 'maintaining authenticity while meeting brand guidelines']. I addressed this by [e.g., 'collaborating closely with the brand to find creative compromises that satisfied both parties']."</p><p style="text-align: start"><strong>Results and Impact</strong>: How did the content perform?</p><p style="text-align: start">Example: "The campaign exceeded expectations across all metrics:</p><ul><li><p>Posts averaged [X%] higher engagement than my usual content</p></li><li><p>Stories saw a [Y%] increase in replies and interactions</p></li><li><p>Reels reached [Z] views, with one going viral and hitting the Explore page</p></li></ul><p style="text-align: start"><strong>Learnings and Future Opportunities</strong>: What did you gain from this experience?</p><p style="text-align: start">Example: "This collaboration honed my skills in creating diverse, platform-optimized content. The success across Posts, Stories, and Reels has opened doors for more comprehensive Instagram campaigns with other brands."</p><p style="text-align: start"><em>Remember to tailor this description to the specific Instagram format(s) you used in your collaboration!</em></p>
      `,
      role: {
        title: '[e.g., Instagram Content Creator, Visual Storyteller, Editor]',
        description:
          '[Describe your key responsibilities, from conceptualization to execution and reporting]',
        organization:
          'What Organization were you working with in this role? [Enter the brand name]',
      },
      links: [
        {
          name: 'Best performing Reel',
          url: 'https://www.example.com',
        },
        {
          name: 'Campaign hashtag page',
          url: 'https://www.example.com/hashtag-results',
        },
      ],
      insights: [
        {
          title: '👀 Impressions',
          description: '1M+ across all campaign content',
        },
        {
          title: '❤️ Engagement Rate',
          description: '8% (2x my average)',
        },
        {
          title: '🔥 Reach',
          description: '500K unique accounts, 30% non-followers',
        },
        {
          title: '🛒 Swipe-Ups/Link Clicks',
          description: '10K clicks to brand website',
        },
        {
          title: '🏆 Brand Impact',
          description: '15% increase in brand awareness among my followers',
        },
      ],
      contentType: [
        'Instagram Reel(s)',
        'Instagram Story',
        'Instagram Post(s)',
        'Follower Swap',
        'Promo Swap',
        'Shoutout',
        'Share',
        'Stream & Co-Stream',
      ],
    },
  },
  {
    title: 'YouTube Post or Shorts Collab',
    id: 'youtube_post_shorts_collab',
    icon: '🎥',
    project: {
      title:
        "🎥 YouTube Magic: [Your Name]'s [Brand] Collaboration [Long-form/Shorts]",
      description: `
        <p>Lights, camera, action! As an influencer marketing expert, I can't wait to see how you showcased this brand collaboration. Follow this guide to create a project description that will make brands eager to work with you:</p><p style="text-align: start"><strong>Hook</strong>: Start with your video's hook or key selling point</p><p style="text-align: start">Example: "In this [Brand] collaboration, I [brief description of video concept] that garnered [X] views and drove [Y] in sales within the first week."</p><p style="text-align: start"><strong>Brand Integration</strong>: How did you seamlessly incorporate the brand?</p><p style="text-align: start">Example: "I integrated [Brand]'s [Product/Service] naturally into my content by [specific strategy, e.g., 'creating a challenge around its key features' or 'using it to solve a common problem my audience faces']."</p><p style="text-align: start"><strong>Content Strategy</strong>: What made your approach unique?</p><p style="text-align: start">Example: "To maximize impact, I:</p><ul><li><p>Researched [Brand]'s target demographic and aligned it with my audience's interests</p></li><li><p>Developed a storyline that showcased [Product/Service] as the hero</p></li><li><p>Optimized for YouTube's algorithm by [specific tactics, e.g., 'using highly searched keywords in title and description']</p></li></ul><p style="text-align: start"><strong>Production Value</strong>: How did you ensure high-quality content?</p><p style="text-align: start">Example: "I elevated the production quality by [e.g., 'using professional lighting and audio equipment', 'incorporating dynamic B-roll footage', 'creating custom graphics to highlight key product features']."</p><p style="text-align: start"><strong>Audience Engagement</strong>: How did you encourage viewer interaction?</p><p style="text-align: start">Example: "To boost engagement, I:</p><ul><li><p>Included a clear call-to-action for viewers to try the product</p></li><li><p>Created a custom hashtag [#YourHashtag] for viewers to share their experiences</p></li><li><p>Responded to comments within the first 24 hours to drive conversation</p></li></ul><p style="text-align: start"><strong>Results and ROI:</strong> What tangible outcomes did you deliver?</p><p style="text-align: start">Example: "The collaboration exceeded expectations:</p><ul><li><p>[X] views within the first 30 days ([Y]% above average)</p></li><li><p>[Z] click-throughs to [Brand]'s website</p></li><li><p>[A]% increase in [Brand]'s social media followers</p></li><li><p>[B] user-generated content posts using our custom hashtag</p></li><li><p>[C] in attributed sales (a [D]% ROI for the brand)</p></li></ul><p style="text-align: start"><strong>Learnings and Adaptability:</strong> How did you optimize based on data?</p><p style="text-align: start">Example: "By closely monitoring performance metrics, I identified that [specific segment of video] resonated most with viewers. I then created a shortened version for YouTube Shorts and Instagram Reels, expanding the campaign's reach across platforms."</p><p style="text-align: start"><strong>Future Opportunities:</strong> How has this positioned you for future collabs?</p><p style="text-align: start">Example: "This successful collaboration has not only strengthened my relationship with [Brand] for future projects but has also showcased my ability to deliver measurable results in the [industry] niche."</p>
      `,
      role: {
        title:
          '[e.g., YouTube Content Creator, Video Strategist, Brand Storyteller]',
        description:
          '[Highlight your end-to-end involvement, from concept development to performance analysis]',
        organization:
          'What Organization were you working with in this role? [Enter the brand name]',
      },
      links: [
        {
          name: 'Full YouTube Video',
          url: 'https://www.example.com',
        },
        {
          name: 'Behind-the-scenes TikTok',
          url: 'https://www.example.com/behind-the-scenes',
        },
        {
          name: 'Key Contact: [Your manager’s name]',
          url: 'https://www.example.com/creatorland-profile',
        },
        {
          name: 'Key Contact: [Name of your contact at the partner brand]',
          url: 'https://www.example.com/creatorland-profile',
        },
      ],
      insights: [
        {
          title: '👀 Total Views',
          description: '500K in first 30 days',
        },
        {
          title: '🕒 Average View Duration',
          description: '4:30 minutes (75% retention rate)',
        },
        {
          title: '👍 Engagement Rate',
          description: '12% (likes, comments, shares)',
        },
        {
          title: '🛒 Conversion Rate',
          description: "3% CTR to brand's site",
        },
        {
          title: '💰 ROI for Brand',
          description: '350% return on investment',
        },
      ],
      contentType: [],
    },
  },
  {
    title: 'Twitch or Gaming Livestream Collab',
    id: 'twitch_gaming_livestream_collab',
    icon: '🎮',
    project: {
      title: "🎮 Level Up: [Your Name]'s [Brand] Gaming Collab on [Platform]",
      description: `
        <p>Ready Player One! As an influencer marketing expert, I'm excited to see how you leveled up this gaming collaboration. Follow this guide to create a project description that will make brands want to hit the "Play" button with you:</p><p style="text-align: start"><strong>Stream Overview</strong>: Set the stage for your epic collab</p><p style="text-align: start">Example: "I partnered with [Brand] for a [X]-hour livestream on [Platform], featuring their [Product/Service] in an immersive [Game Name] experience that drew [Y] concurrent viewers and [Z] total views."</p><p style="text-align: start"><strong>Brand Integration</strong>: How did you seamlessly incorporate the sponsor?</p><p style="text-align: start">Example: "I integrated [Brand] organically by [specific strategy, e.g., 'customizing my stream overlay with their logo', 'creating in-game challenges around their product', 'showcasing their gear during my setup tour']."</p><p style="text-align: start"><strong>Engagement Strategy</strong>: How did you keep viewers hooked?</p><p style="text-align: start">Example: "To maximize engagement, I:</p><ul><li><p>Created a custom emote/badge for subscribers featuring [Brand]'s mascot</p></li><li><p>Ran interactive polls about [Brand]'s products during stream breaks</p></li><li><p>Hosted a giveaway of [Brand]'s [Product] for viewers who shared the stream</p></li></ul><p style="text-align: start"><strong>Community Interaction</strong>: How did you leverage your community?</p><p style="text-align: start">Example: "I encouraged my mods and regulars to share their experiences with [Brand], creating authentic testimonials throughout the stream. We also set up a [Brand]-themed Discord channel for continued discussion post-stream."</p><p style="text-align: start"><strong>Multi-Platform Approach</strong>: Did you extend beyond the main platform?</p><p style="text-align: start">Example: "To amplify reach, I:</p><ul><li><p>Teased the collab on Twitter and Instagram stories pre-stream</p></li><li><p>Clipped key moments for TikTok and YouTube Shorts</p></li><li><p>Hosted a post-stream Q&A about [Brand] on Instagram Live</p></li></ul><p style="text-align: start"><strong>Technical Execution</strong>: How did you ensure a smooth experience?</p><p style="text-align: start">Example: "I elevated the stream quality by:</p><ul><li><p>Using a dual-PC setup for optimal performance</p></li><li><p>Incorporating dynamic scene transitions featuring [Brand]'s assets</p></li><li><p>Setting up a dedicated audio channel for clean [Product] sound demos</p></li></ul><p style="text-align: start"><strong>Results and ROI</strong>: What tangible outcomes did you deliver?</p><p style="text-align: start">Example: "The collaboration crushed it:</p><ul><li><p>Peak concurrent viewers: [X] (50% above my average)</p></li><li><p>Total unique viewers: [Y]</p></li><li><p>Stream clips viewed: [Z] times across platforms</p></li><li><p>[A] new [Brand] product purchases using my code</p></li><li><p>[B] new followers gained during the stream</p></li><li><p>[C]% increase in [Brand]'s social media engagement post-stream</p></li></ul><p style="text-align: start"><strong>Learnings and Future Opportunities</strong>: How has this leveled up your content?</p><p style="text-align: start">Example: "This collab helped me refine my long-form content strategy and showcased my ability to integrate brands naturally in a live environment. It's opened doors for more gaming hardware and peripherals partnerships."</p><p style="text-align: start"><em>💡 Pro Tip: Adding your manager and brand contact showcases your professional network and helps potential collaborators connect with key decision-makers. If they're not on Creatorland yet, inviting them expands your network and enhances the platform's ecosystem!</em></p>
      `,
      role: {
        title:
          '[e.g., Gaming Content Creator, Livestream Specialist, Brand Ambassador]',
        description:
          '[Highlight your responsibilities from pre-stream preparation to post-stream analysis]',
        organization:
          'What Organization were you working with in this role? [Enter the brand name]',
      },
      links: [
        {
          name: 'Full Stream VOD',
          url: 'https://www.example.com',
        },
        {
          name: 'Best Moments Compilation',
          url: 'https://www.example.com/best-moments',
        },
        {
          name: 'Key Contact: [Your manager’s name]',
          url: 'https://www.example.com/creatorland-profile',
        },
        {
          name: 'Key Contact: [Name of your contact at the partner brand]',
          url: 'https://www.example.com/creatorland-profile',
        },
      ],
      insights: [
        {
          title: '👥 Peak Concurrent Viewers',
          description: '10,000 viewers',
        },
        {
          title: '⏱️ Average Watch Time',
          description: '45 minutes per viewer',
        },
        {
          title: '💬 Chat Engagement Rate',
          description: '500 messages per minute',
        },
        {
          title: '🛒 Conversion Rate',
          description: '5% CTR on product links',
        },
        {
          title: '🎉 New Followers/Subscribers',
          description: '2,000 new followers during stream',
        },
      ],
      contentType: [
        'Gaming',
        'Stream',
        'Stream & Co Stream',
        'Creativity & Leisure',
        'Entertainment',
        'Stream Raid',
        'Ambassador or Sponsorship',
        'Host & Co Host',
        'Shoot',
      ],
    },
  },
]
